(() => {
  if (window.kmPdpPriceFormatting) return;
  window.kmPdpPriceFormatting = true;
  const impressionCounts = new WeakMap();
  const updateDiscount = () => {
    const script = document.querySelector('[data-km-pdp-quantity-pricing]');
    if (!script) return;
    const config = JSON.parse(script.textContent);
    if (!config.eligible) return;
    const section = script.closest('.shopify-section') || document;
    const customizer = section.querySelector('[data-customizer]');
    const impressionCount = customizer ? impressionCounts.get(customizer) || 1 : 1;
    const customizerVariants = JSON.parse(section.querySelector('[data-customizer-variants]')?.textContent || '[]');
    const sizeInputs = [...section.querySelectorAll('[data-customizer-size-quantity][data-variant-id]')];
    const formId = section.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const variantId = new URLSearchParams(location.search).get('variant') || formId;
    const selected = config.variants.find(v => String(v.id) === String(variantId)) || config.variants[0];
    const quantity = Math.max(1, Number(section.querySelector('input[name="quantity"]')?.value) || 1);
    const items = sizeInputs.length ? sizeInputs.filter(i => Number(i.value) > 0).map(i => ({
      quantity:Number(i.value),variant:config.variants.find(v => String(v.id) === i.dataset.variantId)
    })).filter(i => i.variant) : [{quantity,variant:selected}];
    const effectiveItems = items.length ? items : [{quantity:1,variant:selected}];
    const resolvedPrices = JSON.parse(customizer?.dataset.resolvedPrices || '{}');
    const prices = effectiveItems.map(item => {
      const tier = [...config.tiers].reverse().find(t => item.quantity >= t[0]);
      // Shopify discounts the line total, then rounds the displayed unit price.
      const customizerVariant = customizerVariants.find(v => String(v.id) === String(item.variant.id));
      if (Object.hasOwn(resolvedPrices, item.variant.id) && resolvedPrices[item.variant.id] == null) return null;
      const basePrice = Object.hasOwn(resolvedPrices, item.variant.id) ? resolvedPrices[item.variant.id] : impressionCount > 1 && Number.isFinite(customizerVariant?.twoImpressionPrice)
        ? customizerVariant.twoImpressionPrice : item.variant.price;
      const lineTotal = basePrice * item.quantity;
      const discountCents = Math.floor(lineTotal * tier[1] / 100 + 1e-8);
      return Math.ceil((lineTotal - discountCents) / item.quantity);
    });
    const unitPrice = Math.min(...prices);
    const formatter = new Intl.NumberFormat('en-US',{style:'currency',currency:config.currency || 'USD'});
    const text = prices.includes(null) ? 'Pricing unavailable for this print combination' : `${new Set(prices).size > 1 ? 'From ' : ''}${formatter.format(unitPrice / 100)}${effectiveItems.some(i => i.quantity > 1) ? ' ea' : ''}`;
    section.querySelectorAll('product-price [ref="priceContainer"], .sticky-add-to-cart__price [ref="priceContainer"]').forEach(container => {
      let price = container.querySelector('[data-km-quantity-price]');
      if (price?.dataset.priceText === text) return;
      price = document.createElement('span');
      price.className = 'price';
      price.dataset.kmQuantityPrice = 'true';
      price.dataset.priceText = text;
      price.textContent = text;
      container.replaceChildren(price);
    });
  };
  const format = () => {
    updateDiscount();
    document.querySelectorAll('product-price [ref="priceContainer"] .price, .sticky-add-to-cart__price [ref="priceContainer"] .price').forEach(price => {
      if (price.querySelector('.km-pdp-price')) return;
      const text = price.textContent.trim().replace(/\/ea\b/g, ' ea');
      const match = text.match(/^(From\s+)?\$(\d[\d,]*)\.(\d{2})(.*)$/);
      if (!match) return;
      const wrapper = document.createElement('span');
      wrapper.className = 'km-pdp-price';
      const accessible = document.createElement('span');
      accessible.className = 'visually-hidden';
      accessible.textContent = text;
      const visual = document.createElement('span');
      visual.setAttribute('aria-hidden', 'true');
      if (match[1]) visual.append(match[1]);
      const symbol = document.createElement('sup');
      symbol.textContent = '$';
      const whole = document.createElement('span');
      whole.textContent = match[2];
      const cents = document.createElement('sup');
      cents.textContent = match[3];
      visual.append(symbol, whole, cents);
      match[4].split(/(\bea\b)/).forEach(part => {
        if (part !== 'ea') { visual.append(part); return; }
        const each = document.createElement('span');
        each.className = 'km-pdp-price__each';
        each.textContent = part;
        visual.append(each);
      });
      wrapper.append(accessible, visual);
      price.replaceChildren(wrapper);
    });
  };
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; format(); });
  }).observe(document.querySelector('main') || document.body, {childList:true, subtree:true, characterData:true});
  document.addEventListener('input', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('customizer:size-quantities-change', schedule);
  document.addEventListener('customizer:impressions-change', event => {
    impressionCounts.set(event.target, Math.max(1, Number(event.detail?.count) || 1));
    schedule();
  });
  function schedule() { setTimeout(format, 0); }
  format();
})();
